import {
  getBrandRootVariables,
  updateAppTheme,
} from 'src/designTokens/themes/utils';
import { setAppHideConfig, setUserInfo } from 'src/models/appConfig/slice';
import { getLmsSessionIdentityKey } from 'src/models/auth/lmsLogin/selector';
import { initLmsConfig } from 'src/models/auth/lmsLogin/thunk';
import { setIsAuthenticated } from 'src/models/auth/slice';
import { setSelectedMenu } from 'src/models/lmsConfig/slice';
import {
  getInputFields,
  initReferrals,
  initRevyreConfig,
  initRevyreHierarchy,
  initUsers,
} from 'src/models/lmsConfig/thunk';
import { setSuperSetDetails } from 'src/modules/header/vymoWeb/slice';
import { store } from 'src/store';
import { setAxiosInstanceAuthToken } from 'src/workspace/axios';
import { initFCM } from 'src/workspace/firebaseCloudMessaging/firebase';
import {
  getClientConfigData,
  getModuleProps,
  isWebPlatform,
} from 'src/workspace/utils';

/** Read persisted session (e.g. localStorage), sync axios + Redux, and run web bootstrap thunks. */
export const applyPersistedSessionToRedux = async () => {
  const configData = getClientConfigData();
  const isLoggedIn = getModuleProps()?.isLoggedIn?.() || configData?.auth_token;
  const isPortalLoggedIn = getModuleProps()?.isPortalLoggedIn?.();

  if (isLoggedIn || isPortalLoggedIn) {
    const sessionIdentityBeforeReload = getLmsSessionIdentityKey(
      store.getState(),
    );
    await store.dispatch(initLmsConfig());
    const sessionIdentityAfterReload = getLmsSessionIdentityKey(
      store.getState(),
    );
    const hasSessionSwappedInSpa =
      sessionIdentityBeforeReload !== '' &&
      sessionIdentityBeforeReload !== sessionIdentityAfterReload;
    if (hasSessionSwappedInSpa) {
      store.dispatch(setSelectedMenu({ menu: null, type: 'direct' }));
      store.dispatch(setSuperSetDetails([]));
    }

    store.dispatch(setIsAuthenticated(true));
    if (isWebPlatform()) {
      store.dispatch(setAppHideConfig({ hide: { copilot: true } }));
      store.dispatch(initUsers());
      store.dispatch(initRevyreHierarchy());
      store.dispatch(initReferrals());
      store.dispatch(initRevyreConfig());
      store.dispatch(getInputFields());
      initFCM();
    }

    updateAppTheme(
      getBrandRootVariables(configData?.branding?.colors?.primary),
    );
    store.dispatch(
      setUserInfo({ clientCode: configData?.client, email: configData?.email }),
    );
  } else {
    setAxiosInstanceAuthToken('');
    store.dispatch(setIsAuthenticated(false));
  }
};
